export const WHITE_LABLED_APPS: String[] = ['ssvm', 'reeds', 'ssvmkidscasa'];
export const BUY_COURSE_LINK = 'https://shop.mindjjo.com/course-enquiry'
